import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Copyright from '../components/copyright/Copyright';
import useUser from '../hook/useUser';

const FullScreenLayout = (props) => {
  const { userData, alertMsg  } = useUser();

  return (
    <>
      <Box>
        {
          userData.role &&
            <>
                <main>
                  { React.cloneElement(props.children, { userData: userData }) }
                </main>
              <Copyright  style={{ color:'#fff', textAlign: 'center' }} />
            </>
        }             
      </Box>
    </>
  );
}

export default FullScreenLayout;